import React from 'react'
import { ReactComponent as TagRibbonIcon } from '@site/images/kitsPassados/tag-ribbon.svg'
import { ReactComponent as TagRibbonWithShadowIcon } from '@site/images/kitsPassados/tag-ribbon-with-shadow.svg'

const TagRibbon = ( { color, height, width, withShadow = false, onClick = () => null }: TagRibbon.Props ): React.ReactElement => {
  const props = {
    'fill': color,
    height,
    width,
    'className': 'tag-ribbon',
    onClick
  }

  return withShadow ? <TagRibbonWithShadowIcon { ...props } /> : <TagRibbonIcon { ...props } />
}

namespace TagRibbon {
  export interface Props {
    color: string
    height?: number
    width?: number
    withShadow?: boolean
    onClick?: () => void
  }
}

export default TagRibbon
